import React from 'react';
import { Text, TouchableOpacity, View, StyleSheet } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { baseActionButton, baseButtonText } from './promptStyles';

export const GradientButton = ({text, onPress, testID}) => (
  <TouchableOpacity testID={testID} onPress={onPress}>
    <LinearGradient
      locations={[0, 0.7, 1]}
      start={{x: 0, y: 0}}
      end={{x: 0, y: 1}}
      colors={['#ffb636', '#ffb636', '#d47d02']}
      style={styles.actionButton}>
      <Text style={styles.buttonText}>{text}</Text>
    </LinearGradient>
  </TouchableOpacity>
);

export const TooltipComponent = ({isVisible, tooltipId, content}) => {
  if (!isVisible) return null;

  return (
    <LinearGradient
      testID={tooltipId}
      locations={[0, 1]}
      colors={['#8a9daf', '#d7e1e9']}
      style={styles.tooltipContainer}>
      <Text style={styles.tooltipText}>{content}</Text>
      <View style={styles.tooltipArrow} />
    </LinearGradient>
  );
};

export const ButtonWithTooltip = ({
  type, 
  onPress = () => {}, 
  buttonText, 
  tooltipText, 
  tooltips, 
  toggleTooltip,
  customButtonStyle = {}
}) => {
  const tooltipKey = `${type}Tooltip`;
  const isTooltipVisible = tooltips[tooltipKey];

  return (
    <View style={styles.buttonWithTooltip}>
      <View style={[styles.buttonRow, customButtonStyle]}>
        <GradientButton
          testID={`${type}Button`}
          text={buttonText}
          onPress={onPress}
        />
        <TouchableOpacity
          testID={`${type}InfoIcon`}
          style={styles.infoIconWrapper}
          onPress={() => toggleTooltip(type)}>
          <i className="icon-info-circled" style={styles.infoIcon}></i>
        </TouchableOpacity>
      </View>
      <TooltipComponent
        isVisible={isTooltipVisible}
        tooltipId={`${type}Tooltip`}
        content={tooltipText}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  buttonWithTooltip: {
    width: '100%',
    position: 'relative',
    marginBottom: 5
  },
  buttonRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginBottom: 5
  },
  actionButton: {
    ...baseActionButton,
    paddingVertical: 8,
    minWidth: '75%',
  },
  buttonText: baseButtonText,
  infoIconWrapper: {
    marginLeft: 10,
    padding: 5
  },
  infoIcon: {
    color: '#1C1C1C',
    fontSize: 24
  },
  tooltipContainer: {
    padding: 12,
    borderRadius: 5,
    marginTop: 5,
    width: '100%',
    position: 'relative',
    zIndex: 2
  },
  tooltipText: {
    color: '#000',
    fontFamily: 'Poppins_300Light',
    fontSize: 14,
    lineHeight: 20
  },
  tooltipArrow: {
    position: 'absolute',
    top: -10,
    left: '45%',
    width: 0,
    height: 0,
    borderLeftWidth: 10,
    borderRightWidth: 10,
    borderBottomWidth: 10,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: '#d7e1e9'
  }
});